import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import { LuEye } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { SlBriefcase } from "react-icons/sl";
import { RiCalendarScheduleLine } from "react-icons/ri";
import { BsPassport } from "react-icons/bs";
import { jobseekerDashboard } from "../../service/apis/dashboard.api";
import { JobseekerDashboard } from "../../config/JobseekerDashboard";
import Loader from "../../common/Loader/loader";
import { Alert } from "../../common/Alert/alert";
import DataTable from "../../common/data-table";
import {
  appliedJobDelete,
  appliedJobDetails,
} from "../../service/apis/auth.api";
import _ from "lodash";
import moment from "moment";
import MessageList from "./common/message-list";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { showError, showSuccess } from "../../utils/Common";

const DashboardScreen = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [dashboardDetails, setDashboardDetails] =
    useState<JobseekerDashboard | null>();
  const [isLoading, setIsLoading] = useState(false);
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [recentAppliedJobsTableData, setRecentAppliedJobsTableData] = useState(
    []
  );
  const [jobDetails, setAppliedJobDetails] = useState<any>();
  const { messageList, chatHistory } = useSelector(
    (state: RootState) => state.chatSlice
  );

  const { user } = useSelector((state: RootState) => state.authSlice);
  const columns = [
    { label: "Job ID", key: "id" },
    { label: "Job Title", key: "title" },
    { label: "Company Name", key: "company_name" },
    { label: "Department", key: "department" },
    { label: "Applied Date", key: "applied_date" },
    { label: "Status", key: "status" },
    { label: "Actions", key: "actions" },
  ];
  useEffect(() => {
    getDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getDashboard = async () => {
    try {
      setIsLoading(true);
      const response = await jobseekerDashboard();

      setDashboardDetails(response?.data);
      const transformed = await transformedData(response?.data?.resentApplied);
      setRecentAppliedJobsTableData(transformed);
    } catch (error: any) {
      showError(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const transformedData = async (applicants: any = []) => {
    return (
      applicants &&
      applicants.map((app: any, index: number) => ({
        id: index + 1,
        title: app?.jobID?.title || "N/A",
        company_name: app?.jobID?.userID?.externalInfo?.name || "N/A",
        department: app?.jobID?.category?.categoryName || "N/A",
        applied_date: app?.createdAt
          ? new Date(app?.createdAt).toLocaleDateString()
          : "N/A", // Format date
        status: app?.status ? _.startCase(_.toLower(app?.status)) : "N/A",
        actions: (
          <div>
            <button
              className="btnnoStyle btn btn-primary"
              onClick={() => handleView(app)}
              style={{ marginRight: "10px" }}
            >
              <LuEye />
            </button>
            <button
              className="btnnoStyle red btn btn-primary"
              onClick={() => handleDelete(app)}
              style={{ marginRight: "10px" }}
            >
              <AiOutlineDelete />
            </button>
          </div>
        ),
      }))
    );
  };

  const handleView = async (row: any) => {
    handleShow();
    try {
      setIsModelLoading(true);
      const response = await appliedJobDetails(row.id);
      setAppliedJobDetails(response?.application);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      setIsModelLoading(false);
    }
  };

  const handleDelete = async (row: any) => {
    Alert.confirm("Are you sure?", "You want to delete this applied job").then(
      async (resp) => {
        if (resp) {
          try {
            const response = await appliedJobDelete(row.id);
            getDashboard();
            showSuccess(response?.message);
          } catch (err: any) {
            showError(err?.message);
          } finally {
            // setLoading(false);
          }
        }
      }
    );
  };
  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                <SidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <TopHeadScreen />
                {isLoading ? (
                  <Loader />
                ) : (
                  <div className="profileJoblisting-holder rightInnerScroll">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="applied-title">
                          <div className="title">
                            <h2>Overview</h2>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <SlBriefcase />
                            </div>
                            <h2 className="redtext">
                              {dashboardDetails?.totalApplied || 0}
                            </h2>
                          </div>
                          <h4>Total Applied Jobs</h4>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <RiCalendarScheduleLine />
                            </div>
                            <h2 className="redtext">
                              {dashboardDetails?.totalInterviewJobs || 0}
                            </h2>
                          </div>
                          <h4>Schedule for Interview</h4>
                        </div>
                      </div>
                      {dashboardDetails && dashboardDetails?.status && (
                        <div className="col-lg-4">
                          <div className="overviewCard">
                            <div className="overviewCardholder">
                              <div className="iconbox">
                                <BsPassport />
                              </div>
                              <h2 className="redtext">
                                {_.startCase(
                                  _.toLower(dashboardDetails?.status)
                                ) || "N/A"}
                              </h2>
                            </div>
                            <h4>Immigration Request Status</h4>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div
                        className={
                          messageList && messageList.length > 0
                            ? "col-lg-9"
                            : "col-lg-12"
                        }
                      >
                        <div className="title">
                          <h2>Applied Jobs</h2>
                        </div>
                        <div className="appliedJobsTable">
                          <div className="table-responsive">
                            <DataTable
                              data={recentAppliedJobsTableData}
                              columns={columns}
                              isShowPagination={false}
                            />
                          </div>
                        </div>
                      </div>
                      {messageList && messageList.length > 0 && (
                        <div className="col-lg-3 msshld ">
                          <div className="title">
                            <h2>Message</h2>
                          </div>
                          <MessageList
                            messageList={messageList}
                            chatHistory={chatHistory}
                            type="dashboard"
                            user={user}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <button
          type="button"
          className="btn-close custom-close-btn"
          onClick={handleClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 9,

            border: "none",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        ></button>
        <Modal.Body>
          {isModelLoading ? (
                  <Loader />
                ) : 
          jobDetails && (
            <div className="afterapplied">
              <h3>{jobDetails?.application?.jobID?.title || ""}</h3>
              <div className="aplyinfo">
                <h4>
                  <strong>Job Title:</strong>{" "}
                  {jobDetails?.application?.jobID?.title || "N/A"}
                </h4>
                <h4>
                  <strong>Company Name:</strong>{" "}
                  {jobDetails?.employer?.externalInfo?.name || "N/A"}
                </h4>
                <h4>
                  <strong>Location:</strong>{" "}
                  {jobDetails?.application?.jobID?.location || "N/A"}
                </h4>
                <h4>
                  <strong>Application Date:</strong>{" "}
                  {jobDetails?.application?.createdAt
                    ? moment(jobDetails?.application?.createdAt).format(
                        "MMM DD, YYYY"
                      )
                    : "N/A"}
                </h4>
                <h4>
                  <strong>Job Type:</strong>{" "}
                  {jobDetails?.application?.jobID?.type?.typeName || "N/A"}
                </h4>
                <h4>
                  <strong>Status:</strong>{" "}
                  {jobDetails?.application?.status.toUpperCase() || "N/A"}
                </h4>
                <h4>
                  <strong>Salary Range:</strong> $
                  {jobDetails?.application?.jobID?.salaryMin} - $
                  {jobDetails?.application?.jobID?.salaryMax}/month
                </h4>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default DashboardScreen;
